import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { AudioSelectButton, ControlButton } from "@livekit/react-components";
import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

export const PreJoinPage = () => {
  // ---------- USER INPUT ----------
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [project, setProject] = useState("");

  // ---------- SETTINGS ----------
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [connectDisabled, setConnectDisabled] = useState(true);
  // const [audioDevice, setAudioDevice] = useState<MediaDeviceInfo>();

  // const navigate = useNavigate();

  // Enable Connect Button
  useEffect(() => {
    setConnectDisabled(!(username && password && project));
  }, [username, password, project]);

  const toggleAudio = () => setAudioEnabled((prev) => !prev);

  // ---------- CONNECT ----------
  const connectToRoom = async () => {
    try {
      // 1. Get token
      const tokenRes = await fetch("https://voice-stage.deepmine.ir/token/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, project }),
      });

      if (!tokenRes.ok) {
        alert("Invalid username, password, or project");
        return;
      }

      const tokenData = await tokenRes.json();
      const livekitToken = tokenData.token;

      // 2. Get final LiveKit URL from backend
      const urlRes = await fetch(
        `https://voice-stage.deepmine.ir/token/get_project_ws_link?project=${project}&token=${livekitToken}`
      );

      const urlData = await urlRes.json();

      if (!urlData.url) {
        alert("Project URL not found");
        return;
      }

      const livekitURL = urlData.url;

      // 3. Open LiveKit room in a new tab
      window.open(livekitURL, "_blank");

    } catch (err) {
      console.error(err);
      alert("Failed to connect to server");
    }
  };

  // ---------- TOGGLE THEME ----------
  const toggleTheme = () => {
    const current = document.documentElement.getAttribute("data-theme");
    document.documentElement.setAttribute(
      "data-theme",
      current === "dark" ? "light" : "dark"
    );
  };

  return (
    <div className="prejoin-container">
      <div className="prejoin-card">
        <h1 className="title">مرکز تماس هوشمند شاتل</h1>
        <p className="subtitle">.لطفاََ اطلاعات زیر رو وارد کنید</p>

        <button onClick={toggleTheme} className="theme-toggle">
          🌙 / ☀️
        </button>

        <div className="entrySection new-entry">
          <div style={{ direction: "rtl", textAlign: "right" }}>
            <label className="label">نام</label>
            <input
              type="text"
              style={{ direction: "rtl", textAlign: "right" }}
              value={username}
              placeholder="نام خود را وارد کنید..."
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div style={{ direction: "rtl", textAlign: "right" }}>
            <label className="label">رمز</label>
            <input
              type="password"
              value={password}
              placeholder="رمز خود را وارد کنید..."
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div style={{ gridColumn: "1 / -1", direction: "rtl", textAlign: "right" }}>
            <label className="label">پروژه</label>
            <input
              type="text"
              value={project}
              placeholder="نام پروژه را وارد کنید..."
              onChange={(e) => setProject(e.target.value)}
            />
          </div>
        </div>

        <div className="controlSection new-controls">
          <AudioSelectButton
            isMuted={!audioEnabled}
            onClick={toggleAudio}
            // onSourceSelected={setAudioDevice}
          />

          <ControlButton
            label="اتصال"
            disabled={connectDisabled}
            icon={faBolt}
            onClick={connectToRoom}
          />
        </div>

        <footer className="footer">.همه این سایت متعلق به شاتل می‌باشد</footer>
      </div>
    </div>
  );
};
